export function stringToArray(str: string | undefined): string[] {
  return (
    str
      ?.split(',')
      .map((s) => s.trim())
      .filter(Boolean) ?? []
  )
}
